import React, { useRef } from "react";
import Slider from "react-slick";
import { twMerge } from "tailwind-merge";

import style from "./ButtonCarousel.module.scss";
import { ButtonCarouselProps } from "./ButtonCarouselProps";
import LeftArrowBox from "./LeftArrowBox";

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  cssEase: "ease-in-out",
  pauseOnHover: true,
  pauseOnFocus: true,
  pauseOnDotsHover: true,
  adaptiveHeight: false,
};

export const ButtonCarousel = ({
  data,
  className,
  switchButtonsClassName,
  switchButtonIcon,
  customSettings,
}: ButtonCarouselProps) => {
  const slickRef = useRef(null);

  return (
    <div
      data-testid="ButtonCarousel"
      className={twMerge("relative h-full w-full @container", className)}
    >
      <Slider
        {...settings}
        ref={slickRef}
        dotsClass={`slick-dots ${style.dots}`}
        {...customSettings}
      >
        {data.map((item, index) => (
          <div key={index}>{item}</div>
        ))}
      </Slider>
      <SwitchButtons
        icon={switchButtonIcon}
        slickRef={slickRef}
        className={switchButtonsClassName}
      />
    </div>
  );
};

const SwitchButtons = ({
  slickRef,
  icon = <LeftArrowBox />,
  className,
}: {
  slickRef: React.MutableRefObject<Slider | null>;
  icon?: JSX.Element;
  className?: string;
}) => (
  <div
    className={twMerge(
      "absolute right-0 top-0 hidden scale-75 gap-4 @[700px]:-bottom-[30px] @[700px]:right-10 @[700px]:top-auto @[700px]:flex @[700px]:scale-100",
      className
    )}
  >
    <div
      aria-label="prev-button"
      className="cursor-pointer"
      onClick={() => slickRef.current?.slickPrev()}
    >
      {icon}
    </div>
    <div
      aria-label="next-button"
      className="rotate-180 cursor-pointer"
      onClick={() => slickRef.current?.slickNext()}
    >
      {icon}
    </div>
  </div>
);
